// Traffic and Engagement Endpoints
export const TRAFFIC_AND_ENGAGEMENT_ENDPOINTS = {
    OVERVIEW: "api/Market/TrafficAndEngagement/Overview",
    OVERVIEW_COMPARE: "api/Market/TrafficAndEngagement/OverviewCompare",
} as const;

// Unique Users Endpoints
export const UNIQUE_USERS_ENDPOINTS = {
    AVERAGE: "widgetApi/IndustryAnalysisOverview/EngagementOverview/Table",
    OVERTIME: "widgetApi/IndustryAnalysisOverview/UniqueUsers/Graph",
    OVERTIME_PERIOD_OVER_PERIOD: "widgetApi/IndustryAnalysisOverview/UniqueUsers/GraphPOP",
} as const;
